<template>
	<div id="NavBar">
		<header>
			<div>
				<a id="header-logo" href="https://shambhalamusicfestival.com" target="_blank" title="Shambhala Music Festival"
					><img :src="logo" alt="Shambhala Music Festival"
				/></a>
				<a
					id="account-menu"
					href="#"
					htmlFor="#nav"
					title="Toggle Account Menu"
					v-on:click="ToggleAccountMenu"
					v-bind:class="{ open: menu_account_open }"
					><i class="fas fa-user-circle"></i
				></a>
				<a
					id="page-menu"
					href="#"
					class="hamburger"
					htmlFor="#nav"
					title="Toggle Page Menu"
					v-on:click="ToggleNavMenu"
					v-bind:class="{ open: menu_nav_open }"
					><i></i><i></i><i></i
				></a>
			</div>
		</header>
		<div id="NavMenus">
			<nav id="NavMenu" v-bind:class="{ open: menu_nav_open }">
				<ul>
					<li>
						<a href="#UserAccount" v-on:click="UserScrollTo"><i class="fas fa-user-circle"></i> User Account</a>
					</li>
					<li>
						<a href="#Messages" v-on:click="MessagesScrollTo"><i class="fas fa-hashtag"></i> Messages</a>
					</li>
					<li>
						<a href="#CredentialExchange" v-on:click="CancelTransfer"><i class="fas fa-ticket-alt"></i> Your Items</a>
					</li>
					<li>
						<a href="#CredentialExchange" v-on:click="StartTransfer"
							><i class="fas fa-sign-out-alt"></i> Start a Transfer</a
						>
					</li>
					<li>
						<a :href="welcome_url" target="_blank" v-on:click="PrintAndDownload"
							><i class="fas fa-print"></i> Print & Download</a
						>
					</li>
					<li>
						<a href="#OrdersDetails" v-on:click="OrdersScrollTo"><i class="fas fa-shopping-cart"></i> Your Orders</a>
					</li>
					<li>
						<a :href="ticket_url" target="_blank" v-on:click="JustClose"
							><i class="fas fa-smile-plus"></i> Upgrade Your Experience</a
						>
					</li>
					<li>
						<a href="#Newsletter" v-on:click="NewsletterScrollTo"><i class="fab fa-telegram-plane"></i> Newsletter</a>
					</li>
					<li>
						<a
							href="https://shambhalamusicfestival.com/tickets/#electronicticketingfaq"
							target="_blank"
							v-on:click="JustClose"
							><i class="fas fa-question-circle"></i> Tickets FAQ</a
						>
					</li>
				</ul>
			</nav>
			<nav id="AccountMenu" v-bind:class="{ open: menu_account_open }">
				<ul>
					<li>
						<a class="photo-container" href="#" v-on:click="UserScrollTo">
							<img id="user_image" v-bind:src="image" v-bind:alt="fullname" />
						</a>
					</li>
					<li>
						<h2>
							<a href="#" v-on:click="UserScrollTo">{{ fullname }}</a>
						</h2>
					</li>
					<li class="clear-after">
						<form class="menu-buttons">
							<button class="float-left" v-on:click="UserEdit">EDIT</button>
							<button class="float-right" v-on:click="Logout">LOGOUT</button>
						</form>
					</li>
				</ul>
			</nav>
		</div>

		<ClaimingDisabledModal
			v-if="showClaimingDisabledModal"
			@close="showClaimingDisabledModal = false"
		/>
	</div>
</template>

<script>
	import ClaimingDisabledModal from "@/components/ClaimingDisabledModal.vue"

	export default {
		name: "NavBar",
		components: { ClaimingDisabledModal },
		data() {
			return {
				user: window.portal.user,
				menu_nav_open: false,
				menu_account_open: false,
				ticket_url: window.portal.ticket_url,
				welcome_url: window.portal.welcome_portal,
				logo: window.portal.logo ? window.portal.logo : process.env.VUE_APP_LOGO,
				showClaimingDisabledModal: false,
			}
		},
		computed: {
			image: function() {
				return window.portal.user.image != "" ? `${window.portal.user.image}` : "/images/user_nophoto.svg"
			},
			fullname: function() {
				return `${this.user.first_name} ${this.user.last_name}`
			}
		},
		mounted: function() {
			window.portal.nav = {}
			window.portal.nav.close = this.JustClose
		},
		methods: {
			ToggleNavMenu(e) {
				if (e) {
					e.preventDefault()
				}
				this.menu_account_open = false
				this.menu_nav_open = !this.menu_nav_open
				window.debug(`MENU NAV ${this.menu_nav_open ? "OPEN" : "CLOSED"}`)
			},
			ToggleAccountMenu(e) {
				if (e) {
					e.preventDefault()
				}
				this.menu_nav_open = false
				this.menu_account_open = !this.menu_account_open
				window.debug(`MENU ACCOUNT ${this.menu_nav_open ? "OPEN" : "CLOSED"}`)
			},
			Logout(e) {
				if (e) {
					e.preventDefault()
				}
				window.portal.logout()
			},
			UserEdit(e) {
				if (e) {
					e.preventDefault()
				}
				window.portal.user.edit_mode = true
				this.UserScrollTo(e)
			},
			UserScrollTo(e) {
				if (e) {
					e.preventDefault()
				}
				this.JustClose()
				window.portal.app.$SmoothScroll(document.getElementById("UserAccount"), 200, function() {
					window.scrollBy({ top: -50, left: 0, behavior: "smooth" })
				})
			},
			JustClose() {
				this.menu_nav_open = false
				this.menu_account_open = false
			},
			MessagesScrollTo(e) {
				if (e) {
					e.preventDefault()
				}
				this.JustClose()
				window.portal.messages.reload()
				window.portal.app.$SmoothScroll(document.getElementById("Messages"), 200, function() {
					window.scrollBy({ top: -50, left: 0, behavior: "smooth" })
				})
			},
			ItemsScrollTo(e) {
				if (e) {
					e.preventDefault()
				}
				this.JustClose()
				window.portal.app.$SmoothScroll(document.getElementById("CredentialExchange"), 200, function() {
					window.scrollBy({ top: -50, left: 0, behavior: "smooth" })
				})
			},
			StartTransfer(e) {
				if (e) {
					e.preventDefault()
				}
				this.JustClose()
				window.portal.creds.startTransfer()
				window.portal.app.$SmoothScroll(document.getElementById("CredentialExchange"), 200, function() {
					window.scrollBy({ top: -50, left: 0, behavior: "smooth" })
				})
			},
			CancelTransfer(e) {
				if (e) {
					e.preventDefault()
				}
				this.JustClose()
				window.portal.creds.cancelTransfer()
				window.portal.app.$SmoothScroll(document.getElementById("CredentialExchange"), 200, function() {
					window.scrollBy({ top: -50, left: 0, behavior: "smooth" })
				})
			},
			PrintAndDownload(e) {
				if(!window.portal.ticket_claiming_enabled) {
					this.showClaimingDisabledModal = true;
					e.preventDefault();
				}
			},
			OrdersScrollTo(e) {
				if (e) {
					e.preventDefault()
				}
				this.JustClose()
				window.portal.app.$SmoothScroll(document.getElementById("OrdersDetails"), 200, function() {
					window.scrollBy({ top: -50, left: 0, behavior: "smooth" })
				})
			},
			NewsletterScrollTo(e) {
				if (e) {
					e.preventDefault()
				}
				this.JustClose()
				window.portal.app.$SmoothScroll(document.getElementById("Newsletter"), 200, function() {
					window.scrollBy({ top: -50, left: 0, behavior: "smooth" })
				})
			}
		}
	}
</script>

<style>
	/* #### Header #### */
	#NavBar {
		position: relative;
		z-index: 9999;
		height: 50px;
		text-align: center;
	}
	header {
		background: var(--navbar-background);
		height: var(--header-height);
		box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.6);
		width: 100%;
		position: fixed;
		z-index: 9999;
		text-align: center;
	}
	header > div {
		display: block;
		position: relative;
		margin: 0px auto;
		text-align: left;
		width: 100%;
		max-width: var(--max-page-width);
		padding: 5px var(--side-margins);
		box-sizing: border-box;
	}
	header a {
		color: var(--navbar-text-color);
	}
	header a:hover {
		color: var(--navbar-text-color-hover);
	}
	header #header-logo {
		display: inline-block;
		width: 150px;
		margin: 2px 0 -2px;
	}
	header #header-logo img {
		width: 100%;
		max-height: 2.5em;
		object-fit: contain;
	}
	/* #### Navigation #### */
	/* ## Defaults ## */
	nav {
		display: block;
		position: relative;
	}
	nav ul {
		display: block;
		list-style: none;
		margin: 0;
		padding: 0;
	}
	nav ul li {
		display: block;
		list-style: none;
		margin: 0;
		padding: 0;
	}
	nav a {
		display: inline-block;
		vertical-align: middle;
	}
	nav ul a {
		display: block;
	}
	nav ul ul {
		display: none;
		position: absolute;
	}
	nav ul li:hover > ul {
		display: block;
	}
	nav ul ul li,
	nav ul ul li a {
		display: block;
		text-align: left;
	}
	nav > a {
		display: none;
	}
	nav .active {
		text-decoration: underline !important;
		-webkit-transform: translate3d(0, 0, 0);
		-moz-transform: translate3d(0, 0, 0);
		-o-transform: translate3d(0, 0, 0);
		-ms-transform: translate3d(0, 0, 0);
		transform: translate3d(0, 0, 0);
	}
	.hamburger {
		display: block;
		position: relative;
		height: 15px;
		width: 18px;
		padding: 0px !important;
	}
	.hamburger i {
		display: block;
		position: absolute;
		height: 18%;
		width: 100%;
		background: var(--navbar-text-color);
		border-radius: 2px;
		transition: 0.5s ease-out;
	}
	.hamburger:hover i {
		background: var(--navbar-text-color-hover);
	}
	.hamburger i:nth-child(1) {
		top: 0;
	}
	.hamburger i:nth-child(2) {
		top: 40%;
	}
	.hamburger i:nth-child(3) {
		top: 80%;
	}
	.hamburger.open i:nth-child(1) {
		transform: rotate(45deg);
		transform-origin: left top;
		top: 4%;
	}
	.hamburger.open i:nth-child(2) {
		opacity: 0;
	}
	.hamburger.open i:nth-child(3) {
		transform: rotate(-45deg);
		transform-origin: left bottom;
		top: 84%;
	}
	.hamburger-menu {
		z-index: 999 !important;
		width: 100%;
		position: absolute;
		margin-top: -2000px;
		transition: all 0.5s ease-in-out 0.2s, visibility 0.5s linear 0.5s, z-index 0s linear 0.5s;
	}
	.hamburger-menu.open {
		margin-top: 70px;
		transition: all 1s ease-in-out 0.2s, visibility 1s linear 1s, z-index 0s linear 1s;
		box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
	}
	/* ## These Menus ## */
	header #account-menu {
		position: absolute;
		top: 12px;
		right: 55px;
		font-size: 1.3em;
		transition: all 0.5s ease-in-out 0.2s, visibility 0.5s linear 0.5s, z-index 0s linear 0.5s;
	}
	header #page-menu {
		position: absolute;
		top: 18px;
		right: 20px;
	}
	nav {
		position: fixed;
		display: inline-block !important;
		top: 0;
		transition: margin 700ms;
		margin-top: -120%;
		width: 100%;
		max-width: 300px;
		background: var(--box-background);
		padding-top: calc(var(--header-height) + 20px);
		box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.4);
	}
	nav a {
		color: var(--box-link-color);
		display: block;
		padding: 5px 15px;
	}
	nav a:hover {
		color: var(--box-link-color-hover);
	}
	nav.open {
		margin-top: 0;
	}
	#NavMenus {
		position: relative;
		width: 100%;
		width: calc(var(--max-page-width) - (300px * 2));
		max-width: calc(100% - (300px * 2));
		text-align: right;
		margin: 0 auto;
	}
	/* ## Account Menu ## */
	#AccountMenu {
		padding-bottom: 25px;
		text-align: center;
	}
	#AccountMenu .photo-container {
		display: block;
		width: 200px;
		height: auto;
		position: relative;
		padding: 0;
		margin: 0 auto;
	}
	#AccountMenu .photo-container:after {
		content: "";
		display: block;
		padding-bottom: 100%;
	}
	#AccountMenu img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		position: absolute;
		top: 0px;
		left: 0px;
		object-fit: cover;
	}
	#AccountMenu .menu-buttons {
		display: block;
		margin: 0 auto;
		max-width: 200px;
	}
	/* ## Navigation Menu ## */
	#NavMenu {
		padding-bottom: 25px;
		text-align: center;
	}
	#NavMenu ul {
		max-width: 300px;
		margin: 0 auto;
		text-align: left;
	}
	#NavMenu ul li {
		border: 0 none;
		border-bottom: 1px solid var(--box-link-color);
	}
	#NavMenu ul li:first-child {
		border-top: 1px solid var(--box-link-color);
	}
	#NavMenu ul li a {
		padding: 10px 15px;
	}
	#NavMenu ul li a:hover {
		background: var(--box-highlight);
	}
	@media only screen and (max-width: 600px) {
		nav {
			max-width: unset;
			left: 0;
		}
		#NavMenu ul {
			margin: auto;
		}
	}
</style>
